import React from 'react';
import eopsIcon from '../../images/eops-loader-icon.png';
import './AppLoader.scss';

const DEFAULT_LABEL = 'Getting Ready';

/**
 * Project loader: eOps icon + 3 clockwise rings.
 * Overlay size is responsive (viewport clamp). Pass a small `size` for buttons.
 * Shows "Getting Ready" under the spinner; pass `label="Please wait..."` (or similar) to
 * change it, or `label=""` to hide it.
 */
const AppLoader = ({ size, label = DEFAULT_LABEL, onLight = false, className = '', style }) => {
  const hasFixedSize = size !== undefined && size !== null && size !== '';
  const numericSize = hasFixedSize
    ? typeof size === 'string'
      ? parseFloat(size) || 0
      : Number(size) || 0
    : 0;
  const compact = hasFixedSize && numericSize > 0 && numericSize < 40;
  const showLabel = !compact && typeof label === 'string' && label.trim().length > 0;
  const labelText = showLabel ? label.trim() : '';

  if (compact) {
    const logoSize = Math.max(numericSize, 14);
    const ringSize = logoSize + 8;

    return (
      <div
        className={`app-loader app-loader--compact ${className}`.trim()}
        style={{ width: ringSize, height: ringSize, ...style }}
        role="status"
        aria-label="Loading"
      >
        <span
          className="app-loader__ring app-loader__ring--1"
          style={{ width: ringSize, height: ringSize }}
        />
        <span
          className="app-loader__ring app-loader__ring--2"
          style={{ width: ringSize - 3, height: ringSize - 3 }}
        />
        <span
          className="app-loader__ring app-loader__ring--3"
          style={{ width: ringSize - 6, height: ringSize - 6 }}
        />
        <img
          src={eopsIcon}
          alt="eOps"
          className="app-loader__logo"
          style={{ width: logoSize, height: logoSize }}
        />
      </div>
    );
  }

  return (
    <div
      className={`app-loader-wrap${onLight ? ' app-loader-wrap--on-light' : ''} ${className}`.trim()}
      style={style}
      role="status"
      aria-label={showLabel ? labelText : 'Loading'}
    >
      <div className="app-loader app-loader--responsive">
        <span className="app-loader__ring app-loader__ring--1" />
        <span className="app-loader__ring app-loader__ring--2" />
        <span className="app-loader__ring app-loader__ring--3" />
        <img src={eopsIcon} alt="eOps" className="app-loader__logo" />
      </div>
      {showLabel ? (
        <span
          className={`app-loader__label${
            labelText === DEFAULT_LABEL ? ' app-loader__label--default' : ''
          }`}
        >
          {labelText}
        </span>
      ) : null}
    </div>
  );
};

export default AppLoader;
